import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { FormControl, FormGroup, NgControl, ReactiveFormsModule, Validators } from '@angular/forms'
import { ControlValueAccessor } from '../../modules/form/core/control-value-accessor'
import { FmxFormSubmitDirective } from '../../modules/form/submit/form-submit.directive'
import { InputComponent } from '../../modules/form/input/input.component'
import { FmxControlSubmitDirective } from '../../modules/form/submit/control-submit.directive'
import { FormGroupValue } from '../../modules/form/core/form-types'

@Component({
	selector: 'app-seller-order-confirmation-form',
	template: `
		<div [formGroup]="control" class="flex-column">
			<app-input formControlName="password" type="password" label="Parola"></app-input>
		</div>
	`,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [ReactiveFormsModule, FmxFormSubmitDirective, InputComponent, FmxControlSubmitDirective],
})
export class SellerOrderConfirmationFormComponent extends ControlValueAccessor<{ password: string }> {
	protected readonly ngControl: NgControl

	readonly control = new FormGroup<FormGroupValue<{ password: string }>>({
		password: new FormControl<string | null>(null, [Validators.required]),
	})

	constructor() {
		const ngControl = inject<NgControl>(NgControl)

		super(ngControl)

		this.ngControl = ngControl
	}
}
